/**
 * 전국 시/도 → 구/군/시 (ㄱㄴ순) with coordinates for geolocation.
 * Used by RegionalRentalPage, SitemapPage, LocationBar, AdminPage district selectors.
 */

const KOREA_REGIONS = [
  {
    region: "서울특별시",
    short: "서울",
    lat: 37.5665,
    lng: 126.978,
    districts: [
      { name: "강남구", lat: 37.5172, lng: 127.0473 },
      { name: "강동구", lat: 37.5301, lng: 127.1238 },
      { name: "강북구", lat: 37.6396, lng: 127.0255 },
      { name: "강서구", lat: 37.5510, lng: 126.8495 },
      { name: "관악구", lat: 37.4784, lng: 126.9516 },
      { name: "광진구", lat: 37.5385, lng: 127.0823 },
      { name: "구로구", lat: 37.4955, lng: 126.8876 },
      { name: "금천구", lat: 37.4568, lng: 126.8955 },
      { name: "노원구", lat: 37.6543, lng: 127.0568 },
      { name: "도봉구", lat: 37.6688, lng: 127.0472 },
      { name: "동대문구", lat: 37.5744, lng: 127.0396 },
      { name: "동작구", lat: 37.5124, lng: 126.9393 },
      { name: "마포구", lat: 37.5664, lng: 126.9012 },
      { name: "서대문구", lat: 37.5791, lng: 126.9368 },
      { name: "서초구", lat: 37.4837, lng: 127.0324 },
      { name: "성동구", lat: 37.5633, lng: 127.0371 },
      { name: "성북구", lat: 37.5894, lng: 127.0167 },
      { name: "송파구", lat: 37.5146, lng: 127.1050 },
      { name: "양천구", lat: 37.5170, lng: 126.8665 },
      { name: "영등포구", lat: 37.5264, lng: 126.8963 },
      { name: "용산구", lat: 37.5326, lng: 126.9907 },
      { name: "은평구", lat: 37.6027, lng: 126.9291 },
      { name: "종로구", lat: 37.5735, lng: 126.9790 },
      { name: "중구", lat: 37.5641, lng: 126.9979 },
      { name: "중랑구", lat: 37.6066, lng: 127.0928 },
    ],
  },
  {
    region: "부산광역시",
    short: "부산",
    lat: 35.1796,
    lng: 129.0756,
    districts: [
      { name: "강서구", lat: 35.2122, lng: 128.9808 },
      { name: "금정구", lat: 35.2429, lng: 129.0923 },
      { name: "기장군", lat: 35.2446, lng: 129.2223 },
      { name: "남구", lat: 35.1368, lng: 129.0843 },
      { name: "동구", lat: 35.1296, lng: 129.0456 },
      { name: "동래구", lat: 35.2045, lng: 129.0838 },
      { name: "부산진구", lat: 35.1631, lng: 129.0532 },
      { name: "북구", lat: 35.1971, lng: 129.0312 },
      { name: "사상구", lat: 35.1526, lng: 128.9908 },
      { name: "사하구", lat: 35.1045, lng: 128.9748 },
      { name: "서구", lat: 35.0977, lng: 129.0243 },
      { name: "수영구", lat: 35.1456, lng: 129.1130 },
      { name: "연제구", lat: 35.1762, lng: 129.0802 },
      { name: "영도구", lat: 35.0912, lng: 129.0687 },
      { name: "중구", lat: 35.1064, lng: 129.0323 },
      { name: "해운대구", lat: 35.1631, lng: 129.1635 },
    ],
  },
  {
    region: "대구광역시",
    short: "대구",
    lat: 35.8714,
    lng: 128.6014,
    districts: [
      { name: "남구", lat: 35.8461, lng: 128.5977 },
      { name: "달서구", lat: 35.8299, lng: 128.5327 },
      { name: "달성군", lat: 35.7745, lng: 128.4314 },
      { name: "동구", lat: 35.8867, lng: 128.6357 },
      { name: "북구", lat: 35.8862, lng: 128.5828 },
      { name: "서구", lat: 35.8718, lng: 128.5592 },
      { name: "수성구", lat: 35.8584, lng: 128.6309 },
      { name: "중구", lat: 35.8693, lng: 128.6062 },
    ],
  },
  {
    region: "인천광역시",
    short: "인천",
    lat: 37.4563,
    lng: 126.7052,
    districts: [
      { name: "강화군", lat: 37.7472, lng: 126.4878 },
      { name: "계양구", lat: 37.5371, lng: 126.7374 },
      { name: "남동구", lat: 37.4488, lng: 126.7319 },
      { name: "동구", lat: 37.4737, lng: 126.6432 },
      { name: "미추홀구", lat: 37.4638, lng: 126.6503 },
      { name: "부평구", lat: 37.5066, lng: 126.7222 },
      { name: "서구", lat: 37.5459, lng: 126.6760 },
      { name: "연수구", lat: 37.4101, lng: 126.6783 },
      { name: "옹진군", lat: 37.4467, lng: 126.6368 },
      { name: "중구", lat: 37.4736, lng: 126.6215 },
    ],
  },
  {
    region: "광주광역시",
    short: "광주",
    lat: 35.1595,
    lng: 126.8526,
    districts: [
      { name: "광산구", lat: 35.1395, lng: 126.7937 },
      { name: "남구", lat: 35.1328, lng: 126.9025 },
      { name: "동구", lat: 35.1455, lng: 126.9231 },
      { name: "북구", lat: 35.1744, lng: 126.9120 },
      { name: "서구", lat: 35.1520, lng: 126.8895 },
    ],
  },
  {
    region: "대전광역시",
    short: "대전",
    lat: 36.3504,
    lng: 127.3845,
    districts: [
      { name: "대덕구", lat: 36.3469, lng: 127.4153 },
      { name: "동구", lat: 36.3118, lng: 127.4549 },
      { name: "서구", lat: 36.3551, lng: 127.3837 },
      { name: "유성구", lat: 36.3621, lng: 127.3563 },
      { name: "중구", lat: 36.3257, lng: 127.4219 },
    ],
  },
  {
    region: "울산광역시",
    short: "울산",
    lat: 35.5384,
    lng: 129.3114,
    districts: [
      { name: "남구", lat: 35.5445, lng: 129.3300 },
      { name: "동구", lat: 35.5049, lng: 129.4166 },
      { name: "북구", lat: 35.5831, lng: 129.3610 },
      { name: "울주군", lat: 35.5225, lng: 129.2431 },
      { name: "중구", lat: 35.5697, lng: 129.3324 },
    ],
  },
  {
    region: "세종특별자치시",
    short: "세종",
    lat: 36.4800,
    lng: 127.2890,
    districts: [
      { name: "세종시", lat: 36.4800, lng: 127.2890 },
    ],
  },
  {
    region: "경기도",
    short: "경기",
    lat: 37.4138,
    lng: 127.5183,
    districts: [
      { name: "가평군", lat: 37.8315, lng: 127.5095 },
      { name: "고양시 덕양구", lat: 37.6376, lng: 126.8322 },
      { name: "고양시 일산동구", lat: 37.6586, lng: 126.7742 },
      { name: "고양시 일산서구", lat: 37.6754, lng: 126.7513 },
      { name: "과천시", lat: 37.4292, lng: 126.9876 },
      { name: "광명시", lat: 37.4786, lng: 126.8650 },
      { name: "광주시", lat: 37.4095, lng: 127.2550 },
      { name: "구리시", lat: 37.5943, lng: 127.1295 },
      { name: "군포시", lat: 37.3617, lng: 126.9352 },
      { name: "김포시", lat: 37.6153, lng: 126.7156 },
      { name: "남양주시", lat: 37.6360, lng: 127.2165 },
      { name: "동두천시", lat: 37.9035, lng: 127.0607 },
      { name: "부천시", lat: 37.5034, lng: 126.7660 },
      { name: "성남시 분당구", lat: 37.3825, lng: 127.1199 },
      { name: "성남시 수정구", lat: 37.4509, lng: 127.1457 },
      { name: "성남시 중원구", lat: 37.4313, lng: 127.1376 },
      { name: "수원시 권선구", lat: 37.2576, lng: 127.0285 },
      { name: "수원시 영통구", lat: 37.2593, lng: 127.0465 },
      { name: "수원시 장안구", lat: 37.3024, lng: 127.0103 },
      { name: "수원시 팔달구", lat: 37.2823, lng: 127.0194 },
      { name: "시흥시", lat: 37.3802, lng: 126.8031 },
      { name: "안산시 단원구", lat: 37.3189, lng: 126.7969 },
      { name: "안산시 상록구", lat: 37.3010, lng: 126.8464 },
      { name: "안성시", lat: 37.0080, lng: 127.2797 },
      { name: "안양시 동안구", lat: 37.3943, lng: 126.9518 },
      { name: "안양시 만안구", lat: 37.3866, lng: 126.9219 },
      { name: "양주시", lat: 37.7854, lng: 127.0459 },
      { name: "양평군", lat: 37.4912, lng: 127.4876 },
      { name: "여주시", lat: 37.2984, lng: 127.6374 },
      { name: "연천군", lat: 38.0966, lng: 127.0746 },
      { name: "오산시", lat: 37.1499, lng: 127.0771 },
      { name: "용인시 기흥구", lat: 37.2801, lng: 127.1151 },
      { name: "용인시 수지구", lat: 37.3219, lng: 127.0986 },
      { name: "용인시 처인구", lat: 37.2341, lng: 127.2009 },
      { name: "의왕시", lat: 37.3449, lng: 126.9684 },
      { name: "의정부시", lat: 37.7381, lng: 127.0337 },
      { name: "이천시", lat: 37.2720, lng: 127.4350 },
      { name: "파주시", lat: 37.7599, lng: 126.7802 },
      { name: "평택시", lat: 36.9921, lng: 127.1129 },
      { name: "포천시", lat: 37.8948, lng: 127.2002 },
      { name: "하남시", lat: 37.5393, lng: 127.2148 },
      { name: "화성시", lat: 37.1994, lng: 126.8313 },
    ],
  },
  {
    region: "강원특별자치도",
    short: "강원",
    lat: 37.8228,
    lng: 128.1555,
    districts: [
      { name: "강릉시", lat: 37.7519, lng: 128.8761 },
      { name: "고성군", lat: 38.3803, lng: 128.4679 },
      { name: "동해시", lat: 37.5247, lng: 129.1143 },
      { name: "삼척시", lat: 37.4500, lng: 129.1651 },
      { name: "속초시", lat: 38.2070, lng: 128.5918 },
      { name: "양구군", lat: 38.1100, lng: 127.9898 },
      { name: "양양군", lat: 38.0754, lng: 128.6189 },
      { name: "영월군", lat: 37.1835, lng: 128.4614 },
      { name: "원주시", lat: 37.3422, lng: 127.9202 },
      { name: "인제군", lat: 38.0696, lng: 128.1706 },
      { name: "정선군", lat: 37.3806, lng: 128.6608 },
      { name: "철원군", lat: 38.1467, lng: 127.3133 },
      { name: "춘천시", lat: 37.8813, lng: 127.7300 },
      { name: "태백시", lat: 37.1642, lng: 128.9856 },
      { name: "평창군", lat: 37.3708, lng: 128.3906 },
      { name: "홍천군", lat: 37.6973, lng: 127.8883 },
      { name: "화천군", lat: 38.1062, lng: 127.7081 },
      { name: "횡성군", lat: 37.4912, lng: 127.9842 },
    ],
  },
  {
    region: "충청북도",
    short: "충북",
    lat: 36.6357,
    lng: 127.4912,
    districts: [
      { name: "괴산군", lat: 36.8153, lng: 127.7864 },
      { name: "단양군", lat: 36.9848, lng: 128.3655 },
      { name: "보은군", lat: 36.4893, lng: 127.7295 },
      { name: "영동군", lat: 36.1751, lng: 127.7764 },
      { name: "옥천군", lat: 36.3068, lng: 127.5714 },
      { name: "음성군", lat: 36.9399, lng: 127.6907 },
      { name: "제천시", lat: 37.1327, lng: 128.1909 },
      { name: "증평군", lat: 36.7854, lng: 127.5815 },
      { name: "진천군", lat: 36.8553, lng: 127.4352 },
      { name: "청주시 상당구", lat: 36.6357, lng: 127.4912 },
      { name: "청주시 서원구", lat: 36.6378, lng: 127.4706 },
      { name: "청주시 청원구", lat: 36.6540, lng: 127.4913 },
      { name: "청주시 흥덕구", lat: 36.6398, lng: 127.4316 },
      { name: "충주시", lat: 36.9910, lng: 127.9261 },
    ],
  },
  {
    region: "충청남도",
    short: "충남",
    lat: 36.5184,
    lng: 126.8000,
    districts: [
      { name: "계룡시", lat: 36.2745, lng: 127.2486 },
      { name: "공주시", lat: 36.4465, lng: 127.1190 },
      { name: "금산군", lat: 36.1085, lng: 127.4880 },
      { name: "논산시", lat: 36.1872, lng: 127.0988 },
      { name: "당진시", lat: 36.8897, lng: 126.6462 },
      { name: "보령시", lat: 36.3334, lng: 126.6128 },
      { name: "부여군", lat: 36.2758, lng: 126.9098 },
      { name: "서산시", lat: 36.7846, lng: 126.4503 },
      { name: "서천군", lat: 36.0802, lng: 126.6918 },
      { name: "아산시", lat: 36.7900, lng: 127.0018 },
      { name: "예산군", lat: 36.6826, lng: 126.8495 },
      { name: "천안시 동남구", lat: 36.8151, lng: 127.1139 },
      { name: "천안시 서북구", lat: 36.8652, lng: 127.1440 },
      { name: "청양군", lat: 36.4592, lng: 126.8021 },
      { name: "태안군", lat: 36.7457, lng: 126.2978 },
      { name: "홍성군", lat: 36.6013, lng: 126.6610 },
    ],
  },
  {
    region: "전북특별자치도",
    short: "전북",
    lat: 35.8203,
    lng: 127.1088,
    districts: [
      { name: "고창군", lat: 35.4358, lng: 126.7020 },
      { name: "군산시", lat: 35.9676, lng: 126.7369 },
      { name: "김제시", lat: 35.8037, lng: 126.8805 },
      { name: "남원시", lat: 35.4165, lng: 127.3907 },
      { name: "무주군", lat: 36.0073, lng: 127.6609 },
      { name: "부안군", lat: 35.7317, lng: 126.7330 },
      { name: "순창군", lat: 35.3742, lng: 127.1375 },
      { name: "완주군", lat: 35.9046, lng: 127.1614 },
      { name: "익산시", lat: 35.9483, lng: 126.9577 },
      { name: "임실군", lat: 35.6179, lng: 127.2791 },
      { name: "장수군", lat: 35.6473, lng: 127.5211 },
      { name: "전주시 덕진구", lat: 35.8395, lng: 127.1204 },
      { name: "전주시 완산구", lat: 35.7912, lng: 127.1400 },
      { name: "정읍시", lat: 35.5699, lng: 126.8558 },
      { name: "진안군", lat: 35.7914, lng: 127.4246 },
    ],
  },
  {
    region: "전라남도",
    short: "전남",
    lat: 34.8161,
    lng: 126.4629,
    districts: [
      { name: "강진군", lat: 34.6417, lng: 126.7672 },
      { name: "고흥군", lat: 34.6047, lng: 127.2853 },
      { name: "곡성군", lat: 35.2823, lng: 127.2924 },
      { name: "광양시", lat: 34.9407, lng: 127.6957 },
      { name: "구례군", lat: 35.2026, lng: 127.4627 },
      { name: "나주시", lat: 35.0154, lng: 126.7104 },
      { name: "담양군", lat: 35.3212, lng: 126.9882 },
      { name: "목포시", lat: 34.8118, lng: 126.3922 },
      { name: "무안군", lat: 34.9905, lng: 126.4815 },
      { name: "보성군", lat: 34.7714, lng: 127.0800 },
      { name: "순천시", lat: 34.9506, lng: 127.4871 },
      { name: "신안군", lat: 34.8273, lng: 126.1071 },
      { name: "여수시", lat: 34.7604, lng: 127.6622 },
      { name: "영광군", lat: 35.2773, lng: 126.5121 },
      { name: "영암군", lat: 34.7988, lng: 126.6970 },
      { name: "완도군", lat: 34.3108, lng: 126.7551 },
      { name: "장성군", lat: 35.3018, lng: 126.7845 },
      { name: "장흥군", lat: 34.6817, lng: 126.9072 },
      { name: "진도군", lat: 34.4869, lng: 126.2632 },
      { name: "함평군", lat: 35.0656, lng: 126.5168 },
      { name: "해남군", lat: 34.5739, lng: 126.5993 },
      { name: "화순군", lat: 35.0644, lng: 126.9867 },
    ],
  },
  {
    region: "경상북도",
    short: "경북",
    lat: 36.4919,
    lng: 128.8889,
    districts: [
      { name: "경산시", lat: 35.8254, lng: 128.7413 },
      { name: "경주시", lat: 35.8562, lng: 129.2247 },
      { name: "고령군", lat: 35.7264, lng: 128.2628 },
      { name: "구미시", lat: 36.1197, lng: 128.3442 },
      { name: "군위군", lat: 36.2428, lng: 128.5728 },
      { name: "김천시", lat: 36.1398, lng: 128.1135 },
      { name: "문경시", lat: 36.5866, lng: 128.1866 },
      { name: "봉화군", lat: 36.8931, lng: 128.7324 },
      { name: "상주시", lat: 36.4109, lng: 128.1590 },
      { name: "성주군", lat: 35.9189, lng: 128.2833 },
      { name: "안동시", lat: 36.5684, lng: 128.7296 },
      { name: "영덕군", lat: 36.4152, lng: 129.3653 },
      { name: "영양군", lat: 36.6677, lng: 129.1124 },
      { name: "영주시", lat: 36.8057, lng: 128.6240 },
      { name: "영천시", lat: 35.9732, lng: 128.9382 },
      { name: "예천군", lat: 36.6575, lng: 128.4525 },
      { name: "울릉군", lat: 37.4844, lng: 130.9057 },
      { name: "울진군", lat: 36.9931, lng: 129.4002 },
      { name: "의성군", lat: 36.3527, lng: 128.6970 },
      { name: "청도군", lat: 35.6474, lng: 128.7340 },
      { name: "청송군", lat: 36.4357, lng: 129.0567 },
      { name: "칠곡군", lat: 35.9955, lng: 128.4017 },
      { name: "포항시 남구", lat: 36.0088, lng: 129.3595 },
      { name: "포항시 북구", lat: 36.0410, lng: 129.3657 },
    ],
  },
  {
    region: "경상남도",
    short: "경남",
    lat: 35.4606,
    lng: 128.2132,
    districts: [
      { name: "거제시", lat: 34.8806, lng: 128.6210 },
      { name: "거창군", lat: 35.6868, lng: 127.9092 },
      { name: "고성군", lat: 35.0594, lng: 128.3223 },
      { name: "김해시", lat: 35.2286, lng: 128.8894 },
      { name: "남해군", lat: 34.8377, lng: 127.8924 },
      { name: "밀양시", lat: 35.5037, lng: 128.7464 },
      { name: "사천시", lat: 35.0036, lng: 128.0641 },
      { name: "산청군", lat: 35.4154, lng: 127.8735 },
      { name: "양산시", lat: 35.3350, lng: 129.0373 },
      { name: "의령군", lat: 35.3222, lng: 128.2617 },
      { name: "진주시", lat: 35.1799, lng: 128.1076 },
      { name: "창녕군", lat: 35.5446, lng: 128.4921 },
      { name: "창원시 마산합포구", lat: 35.1814, lng: 128.5721 },
      { name: "창원시 마산회원구", lat: 35.2200, lng: 128.5797 },
      { name: "창원시 성산구", lat: 35.2283, lng: 128.6811 },
      { name: "창원시 의창구", lat: 35.2540, lng: 128.6580 },
      { name: "창원시 진해구", lat: 35.1548, lng: 128.7069 },
      { name: "통영시", lat: 34.8545, lng: 128.4332 },
      { name: "하동군", lat: 35.0673, lng: 127.7514 },
      { name: "함안군", lat: 35.2723, lng: 128.4063 },
      { name: "함양군", lat: 35.5209, lng: 127.7251 },
      { name: "합천군", lat: 35.5654, lng: 128.1659 },
    ],
  },
  {
    region: "제주특별자치도",
    short: "제주",
    lat: 33.4996,
    lng: 126.5312,
    districts: [
      { name: "서귀포시", lat: 33.2541, lng: 126.5601 },
      { name: "제주시", lat: 33.4996, lng: 126.5312 },
    ],
  },
];

/* ─── Helper: Haversine distance in km ─── */
export function getDistance(lat1, lng1, lat2, lng2) {
  const R = 6371;
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLng = ((lng2 - lng1) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos((lat1 * Math.PI) / 180) *
      Math.cos((lat2 * Math.PI) / 180) *
      Math.sin(dLng / 2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

/* ─── Flat list of all districts across Korea ─── */
export function getAllDistricts() {
  const result = [];
  KOREA_REGIONS.forEach((r) => {
    r.districts.forEach((d) => {
      result.push({
        ...d,
        region: r.region,
        regionShort: r.short,
        districtKey: getDistrictKey(r.short, d.name),
      });
    });
  });
  return result;
}

/* ─── Get total count of all districts ─── */
export function getTotalDistrictCount() {
  return KOREA_REGIONS.reduce((sum, r) => sum + r.districts.length, 0);
}

/* ─── Region/district disambiguation helpers ─── */
export function normalizeRegionKey(regionValue) {
  const value = String(regionValue || "").trim();
  if (!value) return "";
  if (value === "전국") return "전국";
  const found = KOREA_REGIONS.find((r) => r.short === value || r.region === value);
  return found?.short || value;
}

export function getRegionData(regionValue) {
  const key = normalizeRegionKey(regionValue);
  return KOREA_REGIONS.find((r) => r.short === key || r.region === key) || null;
}

export function getDistrictKey(regionValue, districtName) {
  const region = normalizeRegionKey(regionValue);
  const district = String(districtName || "").trim();
  return region && district ? `${region}|${district}` : district;
}

export function getDistrictRegions(districtName) {
  const district = String(districtName || "").trim();
  if (!district) return [];
  return KOREA_REGIONS.filter((r) => r.districts.some((d) => d.name === district));
}

export function regionHasDistrict(regionValue, districtName) {
  const region = getRegionData(regionValue);
  const district = String(districtName || "").trim();
  return Boolean(region && district && region.districts.some((d) => d.name === district));
}

export function splitQualifiedDistrict(value) {
  const raw = String(value || "").trim();
  if (!raw) return { region: "", district: "" };
  for (const r of KOREA_REGIONS) {
    for (const prefix of [r.short, r.region]) {
      if (raw === prefix) return { region: r.short, district: "" };
      if (raw.startsWith(`${prefix} `)) {
        const district = raw.slice(prefix.length).trim();
        return { region: r.short, district };
      }
    }
  }
  return { region: "", district: raw };
}

export function getQualifiedDistrictLabel(regionValue, districtName) {
  const parsed = splitQualifiedDistrict(districtName);
  const region = normalizeRegionKey(regionValue || parsed.region);
  const district = parsed.district || String(districtName || "").trim();
  if (!district) return region || "";
  return region && region !== "전국" ? `${region} ${district}` : district;
}

export function getRentalPathForDistrict(value, fallbackRegion = "") {
  const parsed = splitQualifiedDistrict(value);
  const district = parsed.district || String(value || "").trim();
  let region = normalizeRegionKey(parsed.region || fallbackRegion);
  if (!district) return region ? `/rental/${encodeURIComponent(region)}` : "/rental";
  if (regionHasDistrict(region, district)) {
    return `/rental/${encodeURIComponent(region)}/${encodeURIComponent(district)}`;
  }
  const regions = getDistrictRegions(district);
  if (regions.length === 1) {
    region = regions[0].short;
    return `/rental/${encodeURIComponent(region)}/${encodeURIComponent(district)}`;
  }
  return "/rental";
}

export function findBestDistrictFromText(text) {
  const haystack = String(text || "");
  if (!haystack) return null;
  const includesDistrict = (districtName) => {
    if (haystack.includes(districtName)) return true;
    const stem = districtName.replace(/(구|시|군)$/, "");
    return stem.length >= 2 && haystack.includes(stem);
  };

  const regionsByLength = [...KOREA_REGIONS].sort((a, b) => b.region.length - a.region.length);
  for (const r of regionsByLength) {
    if (!haystack.includes(r.short) && !haystack.includes(r.region)) continue;
    const sortedDistricts = [...r.districts].sort((a, b) => b.name.length - a.name.length);
    for (const d of sortedDistricts) {
      if (includesDistrict(d.name)) {
        return { ...d, region: r.region, regionShort: r.short, districtKey: getDistrictKey(r.short, d.name) };
      }
    }
  }

  const districts = getAllDistricts().sort((a, b) => b.name.length - a.name.length);
  for (const d of districts) {
    if (!includesDistrict(d.name)) continue;
    const regions = getDistrictRegions(d.name);
    if (regions.length === 1) return d;
    return null;
  }
  return null;
}

/* ─── Find region short name for a district name ─── */
export function getRegionForDistrict(districtName) {
  const parsed = splitQualifiedDistrict(districtName);
  if (parsed.region && parsed.district) return parsed.region;
  for (const r of KOREA_REGIONS) {
    if (r.districts.some((d) => d.name === parsed.district || d.name === districtName)) {
      return r.short;
    }
  }
  return null;
}

export default KOREA_REGIONS;
